module.exports = new __parcel__URL__("recruitment_zh-cn.69fb5d65.webp").toString();